module.exports = __webpack_public_path__ + "static/media/William Wirt - 1832.8320205d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/William Wirt - 1832.jpg
// module id = 576
// module chunks = 0